import Vue from 'vue'

import Modal from './components/Modal';
import Loading from './components/partial/Loading';
import vueAwesomeCountdown from 'vue-awesome-countdown'
import LevelSelectorModal from "./components/partial/LevelSelectorModal";
import AvatarSelectorModal from "./components/partial/AvatarSelectorModal";
import BasicTextNotification from "./components/notifications/BasicTextNotification";
import AchievementNotification from "./components/notifications/AchievementNotification";
import NotificationAlerts from "./components/NotificationAlerts";
import Avatar from "./components/partial/Avatar";
import GameEnd from "./components/games/partial/GameEnd";
import Invite from "./components/Invite";

Vue.use(vueAwesomeCountdown, 'vac')
Vue.component('modal', Modal)
Vue.component('level-selector-modal', LevelSelectorModal)
Vue.component('avatar-selector-modal', AvatarSelectorModal)
Vue.component('loading', Loading)
Vue.component('basic-text-notification', BasicTextNotification)
Vue.component('achievement-notification', AchievementNotification)
Vue.component('notification-alerts', NotificationAlerts)
Vue.component('avatar', Avatar)
Vue.component('game-end', GameEnd)
Vue.component('invite', Invite)